import vueIntersectionPlugin from "vue-intersection-plugin-revision";
window.vueIntersectionPlugin = vueIntersectionPlugin;